import { ContentMedium } from '../types'

export const emitContentMediaSelected = (contentMedium: ContentMedium, origin: string, extraArgs: Record<string, any>) => {
  const customEvent = new CustomEvent("content_medium:selected", {
    detail: { contentMedium, origin, ...extraArgs },
    bubbles: true
  });
  console.log(customEvent)
  document.dispatchEvent(customEvent);
}

export const emitEditRendering = (originalUrl: string) => {
  const customEvent = new CustomEvent("content_medium_edit:rendering", {
    detail: { originalUrl: originalUrl },
    bubbles: true,
  });
  document.dispatchEvent(customEvent);
}

export const emitEditSaved = (id: number, transformedUrl: string, originalUrl: string) => {
  const customEvent = new CustomEvent("content_medium_edit:saved", {
    detail: { id, transformedUrl, originalUrl },
    bubbles: true,
  });
  document.dispatchEvent(customEvent);
} 
